import {AxiosResponse} from "axios";
import {BaseMutationOptions, BaseUseMutationResult, useBaseMutation} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {TRIGGERS_QUERY_KEY} from "../queryKeys";
import {ReachTrigger, ReachTriggerPayload} from "./types";

type UpdateTriggerVariables = ReachTriggerPayload & {id: number};

const updateTrigger = async ({id, ...payload}: UpdateTriggerVariables): Promise<ReachTrigger> => {
  const response = await axiosReachInstance.put<ReachTrigger, AxiosResponse<ReachTrigger>, ReachTriggerPayload>(
    `/triggers/${id}`,
    payload
  );
  return response.data;
};

export const useUpdateTrigger = (
  options?: BaseMutationOptions<ReachTrigger, UpdateTriggerVariables>
): BaseUseMutationResult<ReachTrigger, UpdateTriggerVariables> => {
  return useBaseMutation<ReachTrigger, UpdateTriggerVariables>(updateTrigger, {
    ...options,
    prefixKeysToReset: () => [[TRIGGERS_QUERY_KEY]],
  });
};
